import { useCallback, useEffect } from "react";
import { useLoading } from "../AppState";

const useGlobalLoading = () => {
  const setLoadingState = useLoading((state) => state.setLoadingState);
  const setLoading = useCallback(
    (status, isTransparent) => {
      setLoadingState(status, isTransparent);
    },
    [setLoadingState]
  );
  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, [setLoading]);
  return { setLoading };
};

export default useGlobalLoading;
